<template>
    <div class="widget-item user-activity">
        <a v-if="!editDisabled  && !widgetData.required && $parent.createMode" class="remove-widget" @click.prevent="$parent.removeWidget(this.widgetData.id);"><i class="fa fa-times"></i></a>
        <div class="title clearfix">
            <span class="pull-left">{{this.widgetData.data.title}}</span>
            <a href="#" @click.prevent="showActivity()" class="view-more-btn pull-right">See More</a>
        </div>
        <div class="activity-listing">
            <div class="activity-item" v-for="activity in this.widgetData.data.activity">
                <div class="row">
                    <div class="col-12 clearfix">
                        <div class="garnish pull-left"></div>
                        <div class="column pull-left">
                            <div class="activity-date">{{activity.updatedDate}}</div>
                            <div class="activity-time">{{activity.updatedTime}}</div>
                        </div>
                        <div class="column pull-left">
                            <div class="activity-name">{{activity.userName}}</div>
                            <div class="activity-type">{{activity.type}}</div>
                        </div>
                        <div class="actions pull-right">
                            <a :href="'/users/'+activity.userID+'/edit'" class="badge badge-primary">View User</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';

    Vue.use(VueEvents)

    export default {
        name: 'user-activity',
        props: [
            'widgetData',
            'editDisabled',
        ],
        data() {
            return {
                loadedChartData: this.chartData,
            }
        },
        methods: {
            showActivity: function(){
                this.$parent.$parent.$parent.uiStates.activityView = !this.$parent.$parent.$parent.uiStates.activityView;
            },
        }
    };
</script>

<style scoped="" lang="scss">
    .user-activity{
        padding: 15px 10px 15px 25px !important;
        .title{
            margin-right: 19px;
            font-size: 20px;
            color: #7D7D7D;
            // text-align: center;
            margin-bottom: 20px;
            .view-more-btn{
                font-size: 12px;
                    margin-top: 8px;
            }
        }
        .activity-listing{
            max-height:160px;
            overflow-y:auto;
            overflow-x:hidden;
            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-track {
                background: #DEE0E1;
                position: absolute;
                top: 0px;
                bottom: 0px;
                right: 0px;
            }
            &::-webkit-scrollbar-thumb {
                background: #25628F;
                border-radius:2px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #25628F;
            }
            .activity-item{
                margin-bottom: 25px;
                &:last-of-type{
                    margin-bottom: 0px;
                    .garnish:after{
                        display: none;
                    }
                }
                .column{
                    width:80px;
                    margin-right: 20px;
                    &.wide{
                        width: 110px;
                    }
                }
                .actions{
                    margin-bottom: 0px;
                    margin-right:15px;
                }
                .garnish{
                    position: relative;
                    margin-top: 3px;
                    background: #00AFD7;
                    height:11px;
                    width:11px;
                    border-radius:50%;
                    margin-right:9px;
                    &:after{
                        position: absolute;
                        bottom:-105px;
                        left:5px;
                        content:"";
                        width: 1px;
                        height:105px;
                        background-color: #E8E8E8;
                    }
                }
                .activity-date{
                    font-size: 12px;
                    color: #4A4A4A;
                    letter-spacing: 0;
                }
                .activity-type{
                    font-size: 12px;
                    color: #CCCCCC;
                    letter-spacing: 0;
                }
                .activity-name{
                    font-weight: 800;
                    font-size: 12px;
                    color: #4A4A4A;
                    letter-spacing: 0;
                }
                .activity-time{
                    font-size: 12px;
                    color: #CCCCCC;
                    letter-spacing: 0;
                }
            }
        }
        .badge{
            font-size: 10px;
            color: #FFFFFF;
            text-transform: capitalize;
            background: #02A7CD;
            border: 1px solid #02A7CD;
            border-radius: 2px;
            margin-bottom: 0px;
        }
    }
</style>
